export enum InvoiceStatus {
    Draft = 'draft',
    Finalized = 'finalized',
    Paid = 'paid'
}